import { ExpensesValueObjectsCardTypeEnum } from 'generated/resources/graphql'

import { getCardTypeLabel } from 'modules/expenses/lib/cards/getCardTypeLabel'

export const transactionTypeWithCard = (
  card:
    | {
        cardType?: ExpensesValueObjectsCardTypeEnum
        last4?: string | null
      }
    | undefined
    | null
) => {
  if (!card) {
    return ''
  }
  const { cardType, last4 } = card

  if (!cardType || !last4) {
    return ''
  }
  return `${getCardTypeLabel(cardType)} *${last4}`
}
